import { Utils, Logger } from "neo-common";
import { GameManager } from "./GameManager";
import { DataManager } from "./DataManager";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { BaseActions } from "../Channels/Common/Actions/BaseActions";
import { GameApp } from "../GameApp";
import { GambleActions } from "../Channels/Common/Actions/GambleActions";
import { ModuleManager } from "./ModuleManager";
import { AppContext } from "../../Common/AppContext";
import { BetManager } from "./BetManager";

export class RemoteManager {
    public static RemoteControllerEnabled: boolean = false;

    private static Iframe: HTMLIFrameElement;

    public static create(): void {
        if (DEBUG) {
            if (window["QUALITY"] === "4K") {
                const uriObj = Utils.getURIQuery();
                const mode4k = Utils.asBool(Utils.valueOrDefault(uriObj["4k"], false));

                if (mode4k) {
                    RemoteManager.RemoteControllerEnabled = true;
                    RemoteManager.Iframe = <HTMLIFrameElement>document.createElement("iframe");
                    RemoteManager.Iframe.id = "remoteIframe";
                    RemoteManager.Iframe.src = "http://bahrabinsky:7080/dev.html?4k=true";
                    RemoteManager.Iframe.style.position = "absolute";
                    RemoteManager.Iframe.style.width = "2160px";
                    RemoteManager.Iframe.style.height = "1278px";
                    RemoteManager.Iframe.style.left = "2160px";
                    document.body.appendChild(RemoteManager.Iframe);

                    window.addEventListener("message", RemoteManager.receiveMessage);
                }
            }
        }

        if (!RemoteManager.RemoteControllerEnabled && AppContext.clientHost) {
            RemoteManager.RemoteControllerEnabled = AppContext.clientHost.supports.externalMessage === true;

            if (DEBUG) {
                if (RemoteManager.RemoteControllerEnabled) {
                    AppContext.clientHost.on("external-message", RemoteManager.receiveMessage);

                    const chType = AppContext.clientHost.type;
                    Logger.debugGroup(
                        "RemoteManager",
                        `RemoteControllerEnabled was set to true, because clienthost '${chType}' supports external messaging.`,
                    );
                }
            }
        }
    }

    public static startLoad(): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        let data: Object = {
            caller: "game",
            module: "game",
            method: "startLoad",
        };
        RemoteManager.sendMessage(data);
    }

    public static finishLoad(): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        let data: Object = {
            caller: "game",
            module: "game",
            method: "finishLoad",
        };
        RemoteManager.sendMessage(data);
    }

    public static unLoad(): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        let data: Object = {
            caller: "game",
            module: "game",
            method: "unLoad",
        };
        RemoteManager.sendMessage(data);
    }

    public static base(state: string = "idle"): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (DataManager.Autoplay) {
            state = "autoplay" + state;
        }

        let actions: Object;
        let bets: Array<number> = [];
        if (BetManager.Coins != null && BetManager.Coins[BetManager.CoinSize] != null) {
            bets = BetManager.Coins[BetManager.CoinSize];
        }

        switch (state) {
            case "hidden":
                actions = {
                    MENU: "hidden",
                    AUTOPLAY: "hidden",
                    AUTOPLAY_STOP: "hidden",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "hidden",
                    SHOW_LINES: "hidden",
                };
                break;
            case "disable":
                actions = {
                    MENU: "disable",
                    AUTOPLAY: "disable",
                    AUTOPLAY_STOP: "hidden",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "disable",
                    SHOW_LINES: "disable",
                };
                break;
            case "idle":
                actions = {
                    MENU: "enable",
                    AUTOPLAY: "enable",
                    AUTOPLAY_STOP: "hidden",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "enable",
                    SHOW_LINES: "enable",
                };
                break;
            case "win":
                actions = {
                    MENU: "hidden",
                    AUTOPLAY: "enable",
                    AUTOPLAY_STOP: "hidden",
                    GAMBLE_START: "enable",
                    SET_LINE: "hidden",
                    SET_BET: "hidden",
                    SHOW_LINES: "hidden",
                };
                break;
            case "autoplayhidden":
                actions = {
                    MENU: "hidden",
                    AUTOPLAY: "hidden",
                    AUTOPLAY_STOP: "hidden",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "hidden",
                    SHOW_LINES: "hidden",
                };
                break;
            case "autoplaydisable":
                actions = {
                    MENU: "disable",
                    AUTOPLAY: "hidden",
                    AUTOPLAY_STOP: "enable",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "disable",
                    SHOW_LINES: "disable",
                };
                break;
            case "autoplayidle":
                actions = {
                    MENU: "disable",
                    AUTOPLAY: "hidden",
                    AUTOPLAY_STOP: "enable",
                    GAMBLE_START: "hidden",
                    SET_LINE: "hidden",
                    SET_BET: "disable",
                    SHOW_LINES: "disable",
                };
                break;
            case "autoplaywin":
                actions = {
                    MENU: "hidden",
                    AUTOPLAY: "hidden",
                    AUTOPLAY_STOP: "enable",
                    GAMBLE_START: "enable",
                    SET_LINE: "hidden",
                    SET_BET: "hidden",
                    SHOW_LINES: "hidden",
                };
                break;
        }

        let data: Object = {
            caller: "game",
            module: "base",
            method: "enable",
            actions: actions,
            bets: bets,
        };
        RemoteManager.sendMessage(data);
    }

    public static gamble(state: string = "idle"): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        let actions: Object;

        switch (state) {
            case "hidden":
                actions = {
                    RED: "hidden",
                    BLACK: "hidden",
                };
                break;
            case "disable":
                actions = {
                    RED: "disable",
                    BLACK: "disable",
                };
                break;
            case "idle":
                actions = {
                    RED: "enable",
                    BLACK: "enable",
                };
                break;
        }

        let data: Object = {
            caller: "game",
            module: "gamble",
            method: "enable",
            actions: actions,
        };
        RemoteManager.sendMessage(data);
    }

    private static sendMessage(data: Object): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (RemoteManager.usingIframe) {
            if (RemoteManager.iframeIsReady) {
                if (DEBUG) {
                    Logger.debugGroup("RemoteManager", `Sending message through IFRAME, data: `, data);
                }

                RemoteManager.Iframe.contentWindow.postMessage(
                    {
                        data: data,
                    },
                    "*",
                );
            } else {
                if (DEBUG) {
                    Logger.debugGroup(
                        "RemoteManager",
                        `Stopped sending message through IFRAME, iframe is not ready yet!`,
                    );
                }
            }
        } else if (RemoteManager.clientHostSupportMessaging) {
            if (DEBUG) {
                Logger.debugGroup(
                    "RemoteManager",
                    `Sending message client host '${AppContext.clientHost.type}' to target 'touchPanel', data: `,
                    data,
                );
            }

            AppContext.clientHost.sendMessageToExternal(data, ["touchPanel"]);
        } else {
            throw new Error(`Could not find valid channel to send external message to!`);
        }
    }

    private static get usingIframe(): boolean {
        return !Utils.isNullOrUndefined(RemoteManager.Iframe);
    }

    private static get iframeIsReady(): boolean {
        return RemoteManager.usingIframe && !Utils.isNullOrUndefined(RemoteManager.Iframe.contentWindow);
    }

    private static get clientHostSupportMessaging(): boolean {
        return AppContext.clientHost && AppContext.clientHost.supports.externalMessage === true;
    }

    /**
     * Callback when message was received
     * @param message - incoming message structure (JSON object)
     */
    private static receiveMessage(message: Object): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (DEBUG) {
            Logger.debugGroup("RemoteManager", `Incoming message: `, message);
        }

        let data: Object;
        if (RemoteManager.usingIframe) {
            if (message != null && message["data"] != null) {
                data = message["data"];
            }
        } else if (RemoteManager.clientHostSupportMessaging) {
            data = message;
        }

        if (data) {
            if (
                data["receiver"] != null &&
                data["receiver"] === "game" &&
                data["module"] != null &&
                data["method"] != null
            ) {
                switch (data["module"]) {
                    case "game":
                        RemoteManager.gameReceive(data["method"]);
                        break;
                    case "base":
                        if (data["bet"] != null) {
                            RemoteManager.baseReceive(data["method"], data["bet"]);
                        } else {
                            RemoteManager.baseReceive(data["method"]);
                        }
                        break;
                    case "gamble":
                        RemoteManager.gambleReceive(data["method"]);
                        break;
                }
            }
        }
    }

    private static gameReceive(method: string): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (method != null) {
            switch (method) {
                case "loaded":
                    RemoteManager.startLoad();
                    break;
                case "help":
                    ModuleManager.cycleHelp();
                    break;
                case "nextLang":
                    DataManager.LangContainer.changeLanguage(true);
                    break;
            }
        }
    }

    private static baseReceive(method: string, bet: string = ""): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (method != null) {
            switch (method) {
                case "menu":
                    if (GameManager.canExit()) {
                        GameApp.exit();
                    }
                    break;
                case "autoPlay":
                    HtmlController.dispatchAction(BaseActions.ActionAutoplay);
                    break;
                case "autoPlayStop":
                    HtmlController.dispatchAction(BaseActions.ActionAutoplayStop);
                    break;
                case "gambleStart":
                    HtmlController.dispatchAction(GambleActions.ActionGambleStart);
                    break;
                case "setBet":
                    if (bet !== "") {
                        HtmlController.dispatchAction(BaseActions.ActionCoinCountSelectValue + bet);
                        HtmlController.dispatchAction(BaseActions.ActionSpin);
                    } else {
                        HtmlController.dispatchAction(BaseActions.ActionBetCycle);
                    }
                    break;
                case "showLines":
                    HtmlController.dispatchAction(BaseActions.ActionSelectPayline + 1);
                    break;
            }
        }
    }

    private static gambleReceive(method: string): void {
        if (!RemoteManager.RemoteControllerEnabled) {
            return;
        }

        if (method != null) {
            switch (method) {
                case "red":
                    HtmlController.dispatchAction(GambleActions.ActionGambleRed);
                    break;
                case "black":
                    HtmlController.dispatchAction(GambleActions.ActionGambleBlack);
                    break;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/RemoteManager.ts
 **/